export default
{
    "status": 0,
    "data": {
        "posConfig": {
            "supportLanguages": [
                "KO",
                "EN",
                "JP"
            ],
            "defaultLanguage": "KO",
            "useVoiceSupport": true,
            "useAutoOpen": true,
            "useAutoClose": true,
            "autoOpenTime": "0900",
            "autoCloseTime": "2200",
            "currencyUnit": "001",
            "saleUnit": "2",
            "isTaxIncluded": true,
            "amountRoundType": "CEIL",
            "amountUnit": "1",
            "decimalPlace": 0,
            "taxRate": 10,
            "reducedTaxRate": 0,
            "discountRoundType": "CEIL",
            "discountSaleUnit": "2",
            "discountTargetType": "1",
            "useAlarmTalk": false,
            "usePager": false,
            "voucherPrintYN": false,
            "voucherPrintPopupYN": false,
            "receiptPrintYN": true,
            "receiptPrintPopupYN": false,
            "useIdleScreen": true,
            "idleScreenOrderType": 3,
            "idleScreenExtrasType": "3",
            "useIdleScreenAd": "",
            "useIdleScreenText": "",
            "idleScreenButtonHideDelay": 0,
            "returnToIdleDelay": 60,
            "orderScreenNo": "1",
            "templateNo": "A",
            "idleScreenLogo": "",
            "orderScreenLogo": "",
            "mainHighlightColor": "#ff3333",
            "subHighlightColor": "#490a71",
            "mainFontColor": "#ffffff",
            "subFontColor": "#7418ee",
            "backgroundColor": "#e6e6e6",
            "deviceInfoList": [],
            "useKitchenPrinter": true,
            "sideProductExposure": false,
            "recommendProductExposure": false,
            "useAllergyFilter": false,
            "supportPayments": [
                "PAY03",
                "PAY04",
                "PAY16",
                "PAY17",
                "PAY22",
                "PAY23",
                "PAY26",
                "PAY35",
                "PAY41",
                "PAY47",
                "PAY92"
            ],
            "bizTimes": [
                {
                    "DAY": "1",
                    "OPEN_TIME": "0900",
                    "CLOSE_TIME": "2330"
                },
                {
                    "DAY": "2",
                    "OPEN_TIME": "0000",
                    "CLOSE_TIME": "2359"
                },
                {
                    "DAY": "3",
                    "OPEN_TIME": "0000",
                    "CLOSE_TIME": "2359"
                },
                {
                    "DAY": "4",
                    "OPEN_TIME": "1120",
                    "CLOSE_TIME": "0200"
                },
                {
                    "DAY": "5",
                    "OPEN_TIME": "1000",
                    "CLOSE_TIME": "2330"
                },
                {
                    "DAY": "6",
                    "OPEN_TIME": "0900",
                    "CLOSE_TIME": "2330"
                },
                {
                    "DAY": "7",
                    "OPEN_TIME": "0900",
                    "CLOSE_TIME": "2330"
                }
            ]
        },
        "openYn": "N",
        "loginCashierId": "0001"
    },
    "message": ""
}